export const CREATE_SOCIAL_POST_REQUEST = 'CREATE_SOCIAL_POST_REQUEST';
export const CREATE_SOCIAL_POST_SUCCESS = 'CREATE_SOCIAL_POST_SUCCESS';
export const CREATE_SOCIAL_POST_FAILURE = 'CREATE_SOCIAL_POST_FAILURE';

export const EDITING_SOCIAL_POST = 'EDITING_SOCIAL_POST';
export const CREATING_SOCIAL_POST = 'CREATING_SOCIAL_POST';

export const GET_SCHEDULED_MESSAGES_REQUEST = 'GET_SCHEDULED_MESSAGES_REQUEST';
export const GET_SCHEDULED_MESSAGES_SUCCESS = 'GET_SCHEDULED_MESSAGES_SUCCESS';
export const GET_SCHEDULED_MESSAGES_FAILURE = 'GET_SCHEDULED_MESSAGES_FAILURE';

export const DELETE_SCHEDULED_MESSAGE_REQUEST = 'DELETE_SCHEDULED_MESSAGE_REQUEST';
export const DELETE_SCHEDULED_MESSAGE_SUCCESS = 'DELETE_SCHEDULED_MESSAGE_SUCCESS';
export const DELETE_SCHEDULED_MESSAGE_FAILURE = 'DELETE_SCHEDULED_MESSAGE_FAILURE';

export const UPDATE_SCHEDULED_MESSAGE_REQUEST = 'UPDATE_SCHEDULED_MESSAGE_REQUEST';
export const UPDATE_SCHEDULED_MESSAGE_SUCCESS = 'UPDATE_SCHEDULED_MESSAGE_SUCCESS';
export const UPDATE_SCHEDULED_MESSAGE_FAILURE = 'UPDATE_SCHEDULED_MESSAGE_FAILURE';

export const SET_SELECTED_FACEBOOK_PAGE = 'SET_SELECTED_FACEBOOK_PAGE';
export const SET_SELECTED_INSTAGRAM_PAGE = 'SET_SELECTED_INSTAGRAM_PAGE';
export const SET_FACEBOOK_PAGES = 'SET_FACEBOOK_PAGES';



// WEBPACK FOOTER //
// ./src/store/modules/social/mutation-types.js